export default __webpack_public_path__ + "static/mobileDesign-d1aafd530e2ee5cc0f2f9a97ef5a0e80.jpg";